'use client'

import { Input } from 'fukku/Input'
import type { InputProps } from 'fukku/Input/types'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { Controller, useFormContext } from 'react-hook-form'

type OrderInputProps = {
	readonly name: NonNullable<InputProps['name']>
	readonly id: InputProps['id']
	readonly rules: {
		maxLength: number
		regex: string
	}
} & Partial<InputProps>

export function OrderInput({
	name: controllerName,
	id,
	rules: { regex, maxLength },
	...inputProps
}: OrderInputProps): React.ReactNode {
	const { t } = useLabels()
	const { control } = useFormContext()

	const errorMessage = t('form.empty.errormessage')

	return (
		<Controller
			name={controllerName}
			control={control}
			rules={{
				required: { value: true, message: errorMessage },
				pattern: {
					value: new RegExp(regex),
					message: errorMessage, // TODO Add a better key for the specific format error case
				},
				maxLength: {
					value: maxLength,
					message: errorMessage, // TODO Add a better key for the specific format error case
				},
			}}
			render={({
				field: { name, onBlur, onChange, value, ref },
				fieldState: { error },
			}) => (
				<Input
					{...inputProps}
					id={id}
					errorMessage={error ? error.message : undefined}
					label={t('myPurchases.login.order.placeholder')} // TODO Change the key to a more generic related to the form
					name={name}
					onBlur={onBlur}
					onChange={onChange}
					type='text'
					value={value}
					refCallback={ref}
				/>
			)}
		/>
	)
}
